<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" :customClass="customClass" v-dialogDrag @closed="closed" >
    <slot></slot>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click.stop="submitForm" v-loading="$store.state.isLoading">确 定</el-button>
    </div> -->
  </el-dialog>
</template>

<script>
export default{
  props:{
    title:String,
    dialogFormVisible:Boolean,
    customClass:String
  },
  computed:{

  },
  methods:{
    closed(){
      console.log('=== 222 ===');
      this.$emit('closedDialog')
    }
  }
}
</script>

<style>
</style>
